





















































































































































import { Component, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import Payment from '@/models/Accounts/Shared/Payments/Payment';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import PaymentState from '@/components/Accounts/Shared/Payments/PaymentState.vue';
import PaymentStateModel from '@/models/Accounts/Shared/Payments/PaymentState';
import ScheduleFrequency from '@/models/Shared/ScheduleFrequency';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'PaymentDetailsDialog', components: { FieldLabel, PaymentState } })
export default class extends SaascadaVueDialog {

    @Prop({ required: true })
    payment: Payment;

    @Prop({required: true})
    isCustomerAccount: boolean;

    dialog = false;
    PaymentStateModel = PaymentStateModel;
    ScheduleFrequency = ScheduleFrequency;

    get allowCancelPayment() {
        // This scenario only applies to customer accounts
        if (this.isCustomerAccount) {
            const isScheduledPayment = this.payment.state === PaymentStateModel.Scheduled;
            const isToggleEnabled = PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.CancelPayments);
            return isScheduledPayment && isToggleEnabled;
        }
        else {
            return false;
        }
    }

    async cancelSinglePayment() {
        this.dialog = false;
        await DepositAccountModule.cancelPayment(this.payment.id);
        // TODO: Refresh payments view
    }

}
